let addToCartForms = document.querySelectorAll('form.form');
addToCartForms.forEach((form) => {
  form.addEventListener('submit', function(event) {
    event.preventDefault(); 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $(this).serialize(),
      dataType: 'json',
      success: function() {
        let productId = form.closest('.product-card-wrapper')?.dataset.product || form.querySelector('[name="product-id"]')?.value;
        setTimeout(() => {
          let modalRecommended = document.querySelectorAll('#modal-recommended-' + productId)[0];
          let modalContent = modalRecommended.querySelector('product-recommendations');
          if (modalContent) {
            modalRecommended.setAttribute('open', ''); 
          }
        }, 1500)
      }
    });
  })
})